import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withKeys as _withKeys, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createCommentVNode(" <i class=\"pi pi-search \"></i> <span style=\"margin-left:4px\">{{ 'bar title' }} </span> ")
], -1 /* HOISTED */)
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "p-fluid formgrid grid" }
const _hoisted_7 = { class: "flex align-items-center mb-1" }
const _hoisted_8 = { for: "" }
const _hoisted_9 = { class: "p-inputgroup flex-2" }
const _hoisted_10 = {
  key: 0,
  class: "p-inputgroup-addon"
}
const _hoisted_11 = {
  key: 2,
  class: "p-inputgroup-addon"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi pi-times" }, null, -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "p-input-icon-left p-input-icon-right" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1 /* HOISTED */)
const _hoisted_17 = { style: {"text-align":"left"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" {{ colSize }} "),
    _createElementVNode("div", null, [
      _createVNode(_component_Panel, {
        class: "field col-12 md:col-12",
        toggleable: true,
        collapsed: false
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        icons: _withCtx(() => [
          _createVNode(_component_Button, {
            id: "buscar",
            label: "Buscar",
            icon: "pi pi-search",
            class: "mr-2 p-button-rounded p-button-primary p-button-outlined",
            onClick: _ctx.executeSearch
          }, null, 8 /* PROPS */, ["onClick"]),
          _createVNode(_component_Button, {
            id: "limpiar",
            label: "Limpiar filtros",
            icon: "pi pi-trash",
            class: "mr-2 p-button-secondary p-button-rounded",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearFilterData()))
          }),
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.selectedSearch,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSearch) = $event)),
            options: _ctx.fieldsData,
            filter: "",
            optionLabel: "label",
            optionGroupLabel: "label",
            optionValue: "value",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectField($event))),
            optionGroupChildren: "items",
            placeholder: "Selecciona un filtro",
            class: "w-full md:w-14rem mr-5"
          }, {
            optiongroup: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("i", {
                  class: _normalizeClass(slotProps.option.icon)
                }, null, 2 /* CLASS */),
                _createElementVNode("div", _hoisted_3, _toDisplayString(slotProps.option.label), 1 /* TEXT */)
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "options"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSearchFilter, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: (_ctx.dataBase + '.' + item.field?.tableName + '.' + item.field?.field),
                    class: _normalizeClass({'field':true,'col-12':_ctx.colSize==12,'col-6':_ctx.colSize==6,'col-4':_ctx.colSize==4,'col-3':_ctx.colSize==3})
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _withDirectives(_createElementVNode("i", {
                        class: _normalizeClass([_ctx.tables.find(x => x.tableName == item?.field?.tableName)?.idIcon ?? 'pi pi-list', "ml-1 mr-2"])
                      }, null, 2 /* CLASS */), [
                        [_directive_tooltip, item?.field?.tableName]
                      ]),
                      _createElementVNode("label", _hoisted_8, _toDisplayString(item.field?.shortDescription ?? item.field?.fieldAlias ??
                                        item.field?.field), 1 /* TEXT */),
                      _createVNode(_component_Dropdown, {
                        modelValue: item.filter,
                        "onUpdate:modelValue": ($event: any) => ((item.filter) = $event),
                        filter: "",
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.stopPropagateEventDropDown($event))),
                        options: _ctx.getCatalogData(_ctx.CatalogTypeConst.FILTROBUSQUEDA),
                        optionLabel: "description",
                        optionValue: "id",
                        class: "wrap-input ml-1 flex-grow-1"
                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      (_ctx.isType(item.field, _ctx.SqlTypesConst.DATETIME) || _ctx.isType(item.field, _ctx.SqlTypesConst.DATE))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Desde"))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isType(item.field, _ctx.SqlTypesConst.DATETIME) || _ctx.isType(item.field, _ctx.SqlTypesConst.DATE))
                        ? (_openBlock(), _createBlock(_component_Calendar, {
                            key: 1,
                            modelValue: item.rangeDateTime.from,
                            "onUpdate:modelValue": ($event: any) => ((item.rangeDateTime.from) = $event)
                          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isType(item.field, _ctx.SqlTypesConst.DATETIME) || _ctx.isType(item?.field, _ctx.SqlTypesConst.DATE))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Hasta"))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isType(item.field, _ctx.SqlTypesConst.DATETIME) || _ctx.isType(item?.field, _ctx.SqlTypesConst.DATE))
                        ? (_openBlock(), _createBlock(_component_Calendar, {
                            key: 3,
                            modelValue: item.rangeDateTime.to,
                            "onUpdate:modelValue": ($event: any) => ((item.rangeDateTime.to) = $event)
                          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                        : (_ctx.isType(item.field, _ctx.SqlTypesConst.VARCHAR) && _ctx.isCatalogType(item.field))
                          ? (_openBlock(), _createBlock(_component_MultiSelect, {
                              key: 4,
                              modelValue: item.valueList,
                              "onUpdate:modelValue": ($event: any) => ((item.valueList) = $event),
                              options: _ctx.getCatalogData(item.field?.catalogTypeId),
                              filter: true,
                              optionLabel: "description",
                              optionValue: "id",
                              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.stopPropagateEventDropDown($event)))
                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"]))
                          : (_ctx.isType(item.field, _ctx.SqlTypesConst.BIT))
                            ? (_openBlock(), _createBlock(_component_InputSwitch, {
                                key: 5,
                                modelValue: item.value,
                                "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                class: "mr-2"
                              }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createBlock(_component_InputText, {
                                key: 6,
                                modelValue: item.value,
                                "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                maxlength: item.field?.length ?? 25,
                                onKeyup: _withKeys(_ctx.executeSearch, ["enter"])
                              }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "maxlength", "onKeyup"])),
                      _createElementVNode("span", {
                        class: "p-inputgroup-addon",
                        onClick: ($event: any) => (_ctx.removeField(_ctx.dataSearchFilter[index].field))
                      }, _hoisted_14, 8 /* PROPS */, _hoisted_12)
                    ])
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(_component_DataTable, {
      value: _ctx.rows,
      tableStyle: "min-width: 50rem",
      paginator: "",
      rows: 5,
      rowsPerPageOptions: [5, 10, 20],
      selectionMode: "single",
      onRowSelect: _ctx.onRowSelect,
      filters: _ctx.filters
    }, {
      header: _withCtx(() => [
        _createElementVNode("span", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_InputText, {
            id: "searchtable",
            modelValue: _ctx.filters['global'].value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
            placeholder: "Buscar un registro..."
          }, null, 8 /* PROPS */, ["modelValue"]),
          _createElementVNode("i", {
            class: "pi pi-times",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters['global'].value = ''))
          })
        ]),
        _createElementVNode("span", _hoisted_17, [
          _createVNode(_component_MultiSelect, {
            modelValue: _ctx.selectedColumns,
            options: _ctx.initialColumns,
            optionLabel: "header",
            "onUpdate:modelValue": _ctx.onToggle,
            display: "chip",
            placeholder: "Seleccione columnas",
            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.stopPropagateEventDropDown($event))),
            maxSelectedLabels: 3
          }, null, 8 /* PROPS */, ["modelValue", "options", "onUpdate:modelValue"])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode(" No se han encontrado datos para los filtros indicados ")
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderColumns(_ctx.selectedColumns), (col, index) => {
          return (_openBlock(), _createBlock(_component_Column, {
            field: col.field,
            header: col.header,
            key: col.field + '_' + index
          }, {
            body: _withCtx(({ data, field }) => [
              _createTextVNode(_toDisplayString(data[field + _ctx.DataSourceConst.DELIMITERFIELDFORMAT]), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["field", "header"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["value", "onRowSelect", "filters"])
  ], 64 /* STABLE_FRAGMENT */))
}